import {moduloAutoconsumo} from "../diccionarios/autoconsumoModulo";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "../../../shared/utils/utils.service";
import {CommonService} from "../../../shared/utils/common.service";
import {Observable, Subject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class MantenedorSolicitudPedidoVentaService {
  diccionarioModulo: any;
  url: string;
  private readonly clienteSelected: Subject<any> = new Subject<any>();
  private readonly materialSelected: Subject<any> = new Subject<any>();
  private readonly imputacion: Subject<any> = new Subject<any>();
  private readonly lineaDetalle: Subject<any> = new Subject<any>();
  private readonly solicitudVenta: Subject<any> = new Subject<any>();

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
    this.url = this._util.getUrlAutoconsumo();
  }

  materialSelectedEvent(materialSelected: any) {
    this.materialSelected.next(materialSelected);
  }

  materialSelectedListener(): Observable<any> {
    return this.materialSelected.asObservable();
  }

  clienteSelectedEvent(clienteSelected: any) {
    this.clienteSelected.next(clienteSelected);
  }

  clienteSelectedListener(): Observable<any> {
    return this.clienteSelected.asObservable();
  }

  imputacionEvent(imputacion: any) {
    this.imputacion.next(imputacion);
  }

  imputacionListener(): Observable<any> {
    return this.imputacion.asObservable();
  }

  lineaDetalleEvent(lineaDetalle: any) {
    this.lineaDetalle.next(lineaDetalle);
  }

  lineaDetalleListener(): Observable<any> {
    return this.lineaDetalle.asObservable();
  }

  solicitudVentaEvent(solicitudVenta: any) {
    this.solicitudVenta.next(solicitudVenta);
  }

  solicitudVentaListener(): Observable<any> {
    return this.solicitudVenta.asObservable();
  }

  getAllSolicitudPedidoVenta() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.getAll);
  }

  getAllSolicitudPedidoVentaToAprove() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.getAlltoAprove);
  }

  getSolicitudByOficinaVenta(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.getByOficinaVenta + payload.idOficinaVenta);
  }

  borrarSolicitudPedidoVenta(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.delete + payload.idPedido, {});
  }

  editarSolicitudAprobacionEstado(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.autoconsumo.aprobacionPedidoVenta.update, payload);
  }

  borrarSolicitudPedidoVenta2(payload) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.delete + payload.idPedido);
  }

  guardarSolicitud(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.creacion, payload);
  }

  guardarSolicitudCompleta(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.creacionCompleta, payload);
  }

  actualizarSolicitud(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.actualizacion, payload);
  }

  actualizarSolicitudCompleta(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.actualizacionCompleta, payload);
  }

  obtenerListaGerencia() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.mantenedorSolicitudPedidoVenta.getAllGerenciasByToken);
  }

  obtenerListaGerenciaAprob() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.autoconsumo.aprobacionPedidoVenta.getGerenciaAprobByUserToken);
  }

}
